<script>
	// Singleton page-cloaking busy overlay. Driven by the global overlay store; render once in the
	// root layout. Trigger it with showOverlay()/hideOverlay()/withOverlay() from $lib/overlay.svelte.js.
	import { overlay } from '$lib/overlay.svelte.js';
</script>

{#if overlay.count > 0}
	<!-- z above header/bottom-nav (z-40) and the mobile drawer (z-50); covers everything and, being
	     on top, swallows pointer events so the page can't be clicked while work is in progress. -->
	<div
		class="fixed inset-0 z-[70] flex flex-col items-center justify-center bg-navy/40 backdrop-blur-sm"
		role="status"
		aria-live="polite"
		aria-busy="true"
	>
		<div class="h-12 w-12 animate-spin rounded-full border-4 border-stone-dark/50 border-t-wine"></div>
		{#if overlay.message}
			<p class="mt-4 text-sm font-medium text-altar-white">{overlay.message}</p>
		{/if}
		<span class="sr-only">Working…</span>
	</div>
{/if}
